import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'

class MacAddressTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      macaddresstable: null,
      error: false,
      loading: true
    }
  }
  componentDidMount () {
    this.setState({loading: true})
    this.setData(this.props.macaddresstable, this.props.errors)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true, macaddresstable: null})
    this.setData(props.macaddresstable, props.errors)
  }
  async setData (macaddresstable, err) {
    if (!macaddresstable && !err.error) return
    if (err.error) return this.setState({error: err, loading: false})
    this.setState({ macaddresstable: macaddresstable, loading: false, error: false })
  }
  reload () {
    this.setState({loading: true})
    this.props.reload()
  }
  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='Mac Table' icon='microchip' buttons={[{ icon: 'fa-refresh', event: () => this.reload() }]}>
        {this.state.macaddresstable &&
          <pre className='no-overflow mt-10 no-padding'>
            <FlowTable noClass data={this.state.macaddresstable.map(mac => [
              mac.mac,
              mac.serviceType
            ])}>
              <tr>
                <th>Mac</th>
                <th>Service Type</th>
              </tr>
            </FlowTable>
          </pre>
        }
        {this.state.error &&
          <pre className='table-pre mt-10'>
            <div className='error-wrapper'>
              <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching MAC-table {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
            </div>
          </pre>
        }
      </StaticBox>
    )
  }
}
export default MacAddressTable



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/troubleshooting/MacAddressTable.js